import _ from 'lodash';
import { LOCALIZATIONS } from 'root/lib/constants';
import { selectRandomElementFromArray } from '../../../lib/utilityFunctions';

class CurriculumManager {
  constructor(curriculum) {
    this.curriculum = curriculum;
  }

  setCurriculum = (c) => { this.curriculum = c; };

  getPracticePictures(level, setNumber) {
    return this.curriculum.practice_items[`level_${level}`][`set_${setNumber}`].example_words;
  }

  getPracticeTargetSoundId(level, setNumber) {
    return this.curriculum.practice_items[`level_${level}`][`set_${setNumber}`].target_sound_id;
  }

  getPracticeWordPartId(level, setNumber) {
    return this.curriculum.practice_items[`level_${level}`][`set_${setNumber}`].word_part_id;
  }

  getOnboardingWord(level, language) {
    if (level >= 7 && language === LOCALIZATIONS.SPA_ES_DEFAULT) {
      return this.curriculum.words.syllable;
    }
    return this.curriculum.words.phoneme;
  }

  getOnboardingTargetWord(level, language) {
    if (level >= 7 && language === LOCALIZATIONS.SPA_ES_DEFAULT) {
      return this.curriculum.onboarding_items.syllable.target_word;
    }
    return this.curriculum.onboarding_items.phoneme.target_word;
  }

  getTargetWord(level, setNumber, questionNumber) {
    return this.curriculum.standard_items
      .target_words[`level_${level}`][`set_${setNumber}`][`question_${questionNumber}`];
  }

  getDistractors(questionId) {
    return this.curriculum.standard_items.distractors[`question_${questionId}`];
  }

  getOnboardingDistractors(level, language) {
    if (level >= 7 && language === LOCALIZATIONS.SPA_ES_DEFAULT) {
      return this.curriculum.onboarding_items.syllable.distractors;
    }
    return this.curriculum.onboarding_items.phoneme.distractors;
  }

  getFirstQuestionNumber(level, setNumber) {
    const [id] = Object.keys(this.curriculum.standard_items.target_words[`level_${level}`][`set_${setNumber}`]);

    return Number(id.split('_')[1]);
  }

  getPracticeSetsAmount(level) {
    return Object.keys(this.curriculum.practice_items[`level_${level}`]).length;
  }

  getStandardSetsAmount(level, setNumber) {
    return Object.keys(this.curriculum.standard_items.target_words[`level_${level}`][`set_${setNumber}`]).length;
  }

  getBonusLevelAnimal() {
    return selectRandomElementFromArray(this.curriculum.bonus_levels);
  }

  getBonusLevelHeadList(defaultHead, tokensEarned) {
    if (!tokensEarned) {
      return [];
    }

    const headList = _.shuffle(this.curriculum.bonus_levels)
      .map(animal => animal.head)
      .filter(head => head !== defaultHead)
      .slice(0, tokensEarned);

    return [defaultHead, ...headList];
  }

  getBonusLevelBodyList(defaultBody, tokensEarned) {
    if (!tokensEarned) {
      return [];
    }

    const bodyList = _.shuffle(this.curriculum.bonus_levels).map(animal => animal.body)
      .filter(body => body !== defaultBody)
      .slice(0, tokensEarned);

    return [defaultBody, ...bodyList];
  }

  getBonusLevelTailList(defaultTail, tokensEarned) {
    if (!tokensEarned) {
      return [];
    }

    const tailList = _.shuffle(this.curriculum.bonus_levels).map(animal => animal.tail)
      .filter(tail => tail !== defaultTail).slice(0, tokensEarned);

    return [defaultTail, ...tailList];
  }
}

const curriculumManager = new CurriculumManager();

export default curriculumManager;
